import React, { useState } from "react";
import T from "prop-types";
import { CATALOG_URL } from "MODULES/parts/constants";
import api from "APP_ROOT/api";
import { ID } from "APP_ROOT/constants";
import { NoteTooltip as IconTooltip } from "MODULES/shared/components";
import useEventListener from "APP_ROOT/hooks/useEventListener";
import { properCase } from "LIB/formatters/text";
import ImagePortal from "MODULES/shared/components/ImagePortal/ImagePortal";

function Catalog({ part }) {
  if (!part.get(CATALOG_URL)) return null;

  const [open, setOpen] = useState(false);
  const [copying, setCopying] = useState(false);

  const escHandler = ({ key }) => {
    if (["27", "Escape"].includes(key) && open) {
      setOpen(false);
    }
  };

  useEventListener("keydown", escHandler);

  const copyImage = () => {
    try {
      const img = new Image();
      const c = document.createElement("canvas");
      const ctx = c.getContext("2d");

      img.onload = function onload() {
        c.width = this.naturalWidth;
        c.height = this.naturalHeight;
        ctx.drawImage(this, 0, 0);
        setCopying(true);
        setTimeout(() => {
          setCopying(false);
        }, 900);
        c.toBlob(
          blob => {
            navigator.clipboard.write([
              new window.ClipboardItem({
                "image/png": blob
              })
            ]);
          },
          "image/png",
          0.75
        );
      };
      img.crossOrigin = "anonymous"; // if from different origin
      api.parts.show(part.get(ID)).then(({ data }) => {
        img.src = data[CATALOG_URL];
      });
    } catch (e) {
      //
    }
  };

  return (
    <div style={{ width: "100%", paddingTop: "10px" }}>
      <IconTooltip
        icon="fa-copy"
        color="white"
        placement="right"
        className="clickable"
        onClick={copyImage}
        note={copying ? "Copied!" : "Copy To Clipboard"}
      />
      <img
        src={part.get(CATALOG_URL)}
        alt={properCase(CATALOG_URL)}
        width={140}
        style={{
          boxShadow: "rgb(0 0 0 / 80%) 4px 12px 17px",
          display: "block",
          margin: "0 auto",
          cursor: "pointer"
        }}
        onClick={() => setOpen(!open)}
      />
      {open && (
        <ImagePortal
          setOpen={setOpen}
          name={properCase(CATALOG_URL)}
          url={part.get(CATALOG_URL)}
          open={open}
        />
      )}
    </div>
  );
}

Catalog.propTypes = {
  part: T.instanceOf(Map)
};

export default Catalog;



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Catalog.jsx